/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, amount: NonNullable<unknown> }} Partner_Admin_Billing_Waive_SuccessInputs */



/**
* | output |
* | --- |
* | "Billing enabled — {count} reports ({amount}) waived." |
*
* @param {Partner_Admin_Billing_Waive_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_billing_waive_success = /** @type {((inputs: Partner_Admin_Billing_Waive_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Billing_Waive_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Abrechnung aktiviert — ${i?.count} Berichte (${i?.amount}) erlassen.`)
	return /** @type {LocalizedString} */ (`Billing enabled — ${i?.count} reports (${i?.amount}) waived.`)
});